import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    uncheckedSecondary: {
        color: theme.palette.secondary.main,
    },
    uncheckedError: {
        color: theme.palette.error.main,
    },
}));
